import React from 'react'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'
import ContactUs from '../ContactUs/ContactUs'

export default function ConceptPage() {
  return (
    <>
      <Navbar />
      <ContactUs />
      <Footer />
    </>
  )
}
